import { useState } from 'react';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';
import { forwardRef } from 'react';
import styles from './input-search-compact.module.less';

const InputSearchCompact = ({ shouldAutoFocus = false, title = 'Søk', name, type, value, onChange }, ref) => {
    const [focused, setFocused] = useState(shouldAutoFocus);

    return (
        <form autoComplete={'off'} onSubmit={(e) => e.preventDefault()}>
            <label className={[focused ? styles.focused : '', styles.searchFieldContainer].join(' ')}>
                <i
                    className={['fa-solid fa-magnifying-glass', styles.icon, focused ? styles.focused : ''].join(' ')}
                    aria-hidden
                />
                <ScreenReaderOnly>{title}</ScreenReaderOnly>
                <input
                    autoFocus={shouldAutoFocus}
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={() => {
                        setFocused(false);
                    }}
                    onFocus={() => setFocused(true)}
                    placeholder={title}
                    ref={ref}
                    autoComplete={'off'}
                    className={focused ? styles.focused : undefined}
                />
            </label>
        </form>
    );
};

export default forwardRef(InputSearchCompact);
